import FormSearchableMultipleSelectionInput from './FormSearchableMultipleSelectionInput';
import { FormSearchSelectionInputProps } from './types';

export type { FormSearchSelectionInputProps };
export default FormSearchableMultipleSelectionInput;
